// Load all the supported locales for the relative date formatting
// Date-FNs locales can be found here: https://github.com/date-fns/date-fns/tree/master/src/locale
import bg from 'date-fns/locale/bg'
import de from 'date-fns/locale/de'
import enUs from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import fr from 'date-fns/locale/fr'
import frCa from 'date-fns/locale/fr-CA'
import hi from 'date-fns/locale/hi'
import it from 'date-fns/locale/it'
import nlBe from 'date-fns/locale/nl-BE'
import pt from 'date-fns/locale/pt'
import th from 'date-fns/locale/th'
import vi from 'date-fns/locale/vi'
import zhCn from 'date-fns/locale/zh-CN'

// Translate the codes we use in i18next to the locales for date-fns
const locales = {
  'en-US': enUs,
  'bg-BG': bg,
  'de-DE': de,
  'es-419': es,
  'es-CL': es,
  'es-CO': es,
  'es-EC': es,
  'es-ES': es,
  'es-MX': es,
  'es-PE': es,
  'fr-CA': frCa,
  'fr-FR': fr,
  hi: hi,
  'it-IT': it,
  'nl-BE': nlBe,
  'pt-PT': pt,
  th: th,
  vi: vi,
  'zh-CN': zhCn,
  default: enUs
}

export default locales
